import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {CreateProduct, ProductService, UpdateProduct} from "../services/product-service";
import {useGlobalSnackbarStore} from "../stores/global-snackbar-store";

export const useAdminProducts = () => {
    const {error, success} = useGlobalSnackbarStore((state) => state);
    const queryClient = useQueryClient();

    const queryInfo = useQuery({
        queryKey: ['admin', 'products'],
        queryFn: async () => await ProductService.list(),
    });

    const invalidateProductQueries = async () => await queryClient.invalidateQueries({queryKey: ['admin', 'products']});

    const {mutateAsync: createProduct, isPending: isCreateProductPending} = useMutation({
        mutationFn: async (product: CreateProduct) => await ProductService.create(product),
        onSuccess: () => success('Produkt angelegt.'),
        onError: () => error('Fehler beim Anlegen des Produkts!'),
        onSettled: invalidateProductQueries,
    });

    const {mutateAsync: updateProduct, isPending: isUpdateProductPending} = useMutation({
        mutationFn: async ({productId, product}: {
            productId: string,
            product: UpdateProduct,
        }) => await ProductService.update(productId, product),
        onSuccess: () => success('Produkt gespeichert.'),
        onError: () => error('Fehler beim Speichern des Produkts!'),
        onSettled: invalidateProductQueries,
    });

    const {mutateAsync: linkCreemProduct, isPending: isLinkCreemProductPending} = useMutation({
        mutationFn: async ({productId, creemProductId}: {
            productId: string,
            creemProductId: string,
        }) => await ProductService.linkToCreemProduct(productId, creemProductId),
        onSuccess: () => success('Creem-Produkt verknüpft.'),
        onError: () => error('Fehler beim Verknüpfen des Creem-Produkts!'),
        onSettled: invalidateProductQueries,
    });

    return {
        ...queryInfo,
        get products() { return queryInfo.data; },
        createProduct,
        isCreateProductPending,
        updateProduct,
        isUpdateProductPending,
        linkCreemProduct,
        isLinkCreemProductPending,
    };
};
